import { useEffect, useState } from 'react';
import Switch from '@mui/material/Switch';
import Tooltip from '@mui/material/Tooltip';
import { updateAppAuxIsSafeToEdit } from '../../_api';
import { AppModel } from '../../../../Classes/ResponseModels/Apps';
const EditSafetyToggle = ({ selectedApp, currentUser, setSelectedApp }) => {
	const [disabled, setDisabled] = useState(true);

	useEffect(() => {
		if (currentUser?.Roles?.some(role => role.Full === 'DEV Team')) {
			setDisabled(false);
		} else {
			setDisabled(true);
		}
	}, [currentUser]);

	const handleUpdate = () => {
		updateAppAuxIsSafeToEdit(
			selectedApp,
			!selectedApp.appAux.isSafeToEdit,
			currentUser
		).then(response => setSelectedApp(new AppModel(response.data)));
	};

	return (
		<>
			{selectedApp ? (
				<Tooltip title='If toggled on, will display warning message when selecting this app'>
					<div>
						{disabled ? (
							<Switch
								disabled
								checked={selectedApp.appAux.isSafeToEdit}
							/>
						) : (
							<Switch
								checked={selectedApp.appAux.isSafeToEdit}
								onClick={handleUpdate}
							/>
						)}
					</div>
				</Tooltip>
			) : null}
		</>
	);
};

export default EditSafetyToggle;
